import {NgModule} from "@angular/core";
import {Routes} from "@angular/router";
import {AdminGuardProvider} from "@core/security/admin-guard.provider";
import {ShareModule} from "@share/share.module";
import {FraisIndemnitesComponent} from "./frais-indemnites.component";
import {IndemnitesParametresComponent} from "@components/admin/frais/indemnites/indemnites-parametres/indemnites-parametres.component";
import {IndemnitesReglesAttributionComponent} from "@components/admin/frais/indemnites/indemnites-regles-attribution/indemnites-regles-attribution.component";
import {IndemnitesReglesAttributionListItemComponent} from "@components/admin/frais/indemnites/indemnites-regles-attribution/indemnites-regles-attribution-list-item/indemnites-regles-attribution-list-item.component";
import {IndemnitesRegleAttributionDetailComponent} from "@components/admin/frais/indemnites/indemnites-regles-attribution/detail/indemnites-regle-attribution-detail.component";
import {IndemnitesRegleAttributionPrestationAddComponent} from "@components/admin/frais/indemnites/indemnites-regles-attribution/detail/prestation-add/indemnites-regle-attribution-prestation-add.component";
import {IndemnitesRegleAttributionGeneralitesComponent} from "@components/admin/frais/indemnites/indemnites-regles-attribution/detail/generalites/indemnites-regle-attribution-generalites.component";
import {IndemnitesAbattementsComponent} from "@components/admin/frais/indemnites/indemnites-abattements/indemnites-abattements.component";
import {IndemnitesAbattementsListItemComponent} from "@components/admin/frais/indemnites/indemnites-abattements/indemnites-abattements-list-item/indemnites-abattements-list-item.component";
import {IndemnitesAbattementDetailComponent} from "@components/admin/frais/indemnites/indemnites-abattements/detail/indemnites-abattement-detail.component";
import {IndemnitesAbattementGeneralitesComponent} from "@components/admin/frais/indemnites/indemnites-abattements/detail/generalites/indemnites-abattement-generalites.component";
import {IndemnitesFraisMissionsComponent} from "@components/admin/frais/indemnites/indemnites-frais-missions/indemnites-frais-missions.component";
import {IndemnitesFraisMissionsListItemComponent} from "@components/admin/frais/indemnites/indemnites-frais-missions/indemnites-frais-missions-list-item/indemnites-frais-missions-list-item.component";
import {IndemnitesFraisMissionsDetailComponent} from "./indemnites-frais-missions/indemnites-frais-missions-detail/indemnites-frais-missions-detail.component";
import {DateApplicationPopinComponent} from "./indemnites-frais-missions/indemnites-frais-missions-detail/date-application-popin/date-application-popin.component";
import {DateApplicationListItemComponent} from "./indemnites-frais-missions/indemnites-frais-missions-detail/date-application-list-item/date-application-list-item.component";
import {FraisMissionDuplicationPopinComponent} from "./indemnites-frais-missions/indemnites-frais-missions-detail/frais-mission-duplication-popin/frais-mission-duplication-popin.component";
import {FraisMissionService} from "@services/admin/frais/frais-mission.service";
import {DroitAdmin} from "@core/security/droit-admin";
import {PreviewAlerteModule} from "@share/component/alerte/preview-alerte.module";

export const fraisIndemnitesRoutes : Routes = [
    {
        path: 'FraisMissions/:idTaux',
        component: IndemnitesFraisMissionsDetailComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_IJ_GESTION] }
    }, {
        path: 'FraisMissions',
        component: IndemnitesFraisMissionsComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_IJ_GESTION] }
    }, {
        path: 'ReglesAttribution',
        component: IndemnitesReglesAttributionComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_IJ_GESTION] }
    }, {
        path: 'ReglesAttribution/:idRegleAttribution',
        component: IndemnitesRegleAttributionDetailComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_IJ_GESTION] }
    }, {
        path: 'Abattements/:idAbattement',
        component: IndemnitesAbattementDetailComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_IJ_GESTION] }
    }, {
        path: 'Abattements',
        component: IndemnitesAbattementsComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_IJ_GESTION] }
    }, {
        path: 'Parametres',
        component: IndemnitesParametresComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_IJ_GESTION] }
    }, {
        path: '',
        pathMatch: 'full',
        redirectTo: 'FraisMissions'
    }, {
        path: '**',
        redirectTo: 'FraisMissions'
    }
];

@NgModule({
    imports: [ShareModule, PreviewAlerteModule],
    declarations: [
        FraisIndemnitesComponent,
        IndemnitesParametresComponent,
        IndemnitesReglesAttributionComponent,
        IndemnitesReglesAttributionListItemComponent,
        IndemnitesRegleAttributionDetailComponent,
        IndemnitesRegleAttributionPrestationAddComponent,
        IndemnitesRegleAttributionGeneralitesComponent,
        IndemnitesAbattementsComponent,
        IndemnitesAbattementsListItemComponent,
        IndemnitesAbattementDetailComponent,
        IndemnitesAbattementGeneralitesComponent,
        IndemnitesFraisMissionsComponent,
        IndemnitesFraisMissionsListItemComponent,
        IndemnitesFraisMissionsDetailComponent,
        DateApplicationPopinComponent,
        DateApplicationListItemComponent,
        FraisMissionDuplicationPopinComponent
    ],
    exports: [
        IndemnitesParametresComponent,
        IndemnitesReglesAttributionComponent,
        IndemnitesAbattementsComponent,
        IndemnitesFraisMissionsComponent
    ],
    providers: [FraisMissionService]
})
export class FraisIndemnitesModule {}
